import React from 'react'
import * as styled from './styles'

interface Props {
    to: string,
    children: string
    "data-testid": string
}
const HashNavLink = (props: Props) => {
  const { to, children } = props;
  const testId = props["data-testid"];
  return (
    <styled.ListItem>
      <styled.HashLink to={to} data-testid={testId}>
          {children}
      </styled.HashLink>
    </styled.ListItem>
  )
}

export default HashNavLink